import service from '../service.js'

export default {
  /**
   * 鑾峰彇璁惧宸ヨ壓绫诲瀷
   * @returns 
   */
  GetEquipmentProcessTypes: () => {
    return service({
      url: '/EquipmentInfo/GetEquipmentProcessTypes',
      method: 'get',
    })
  },
  /**
   * 鑾峰彇璁惧鏈烘绫诲瀷
   * @returns 
   */
  GetEquipmentMechanicalTypes: () => {
    return service({
      url: '/EquipmentInfo/GetEquipmentMechanicalTypes',
      method: 'get',
    })
  },
  /**
   * 娣诲姞璁惧淇℃伅
   * @param {*} params 
   * @returns 
   */
  AddEquipment: (params) => {
    return service({
      url: '/EquipmentInfo/AddEquipment',
      method: 'post',
      data: params
    })
  },
  /**
   * 鏍规嵁鏌ヨ鏉′欢鑾峰彇璁惧淇℃伅鍒楄〃
   * @param {*} companyId 
   * @param {*} equipmentId 
   * @param {*} mechanicalTypeId 
   * @param {*} processTypeId 
   * @param {*} assetCode 
   * @returns 
   */
  GetEquipments: (companyId, equipmentId, mechanicalTypeId, processTypeId, assetCode) => {
    return service({
      url: '/EquipmentInfo/GetEquipments',
      method: 'get',
      params: { companyId, equipmentId, mechanicalTypeId, processTypeId, assetCode }
    })
  },
  /**
   * 缂栬緫璁惧淇℃伅
   * @param {*} params 
   * @returns 
   */
  EditEquipment: (params) => {
    return service({
      url: '/EquipmentInfo/EditEquipment',
      method: 'post',
      data: params
    })
  },
  /**
   * 鑾峰彇璁惧鍑哄巶妫€楠岄」鐩ā鏉?   * @param {*} sortId 璁惧鍒嗙被 Id
   * @returns
   */
  GetFactoryInspectionItemTemplates: (sortId) => {
    return service({
      url: '/EquipmentInfo/GetFactoryInspectionItemTemplates',
      method: 'get',
      params: { sortId }
    })
  },
  /**
   * 鑾峰彇璁惧鍑哄巶妫€楠岃褰?   * @param {*} equipmentId 璁惧 Id
   * @returns
   */
  GetFactoryInspectionRecords: (equipmentId) => {
    return service({
      url: '/EquipmentInfo/GetFactoryInspectionRecords',
      method: 'get',
      params: { id: equipmentId }
    })
  },
  /**
   * 鏇存柊璁惧鍑哄巶妫€楠岃褰曟鏌ヤ汉
   * @param {*} params
   * @returns
   */
  UpdateFactoryInspectionRecordInspector: (params) => {
    return service({
      url: '/EquipmentInfo/UpdateFactoryInspectionRecordInspector',
      method: 'post',
      data: params
    })
  },
}

